module.exports = __webpack_public_path__ + "img/9788993178616.d66b241e.jpg";